module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagef"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xi-02.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "h2n"
  }, [_vm._v("PRELUDE")]), _vm._v(" "), _c('p', {
    staticClass: "h2c"
  }, [_vm._v("edition 2.0")]), _vm._v(" "), _c('p', {
    staticClass: "imagef1"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/line.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ccenter"
  }, [_c('em', [_vm._v("The purpose of life is to discover your gift.")])]), _vm._v(" "), _c('p', {
    staticClass: "ccenter"
  }, [_c('em', [_vm._v("The meaning of life is to give your gift away.")])]), _vm._v(" "), _c('p', {
    staticClass: "ccenter1"
  }, [_vm._v("—David Viscott")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "underlev"
  }, [_vm._v("What a Thrill!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hard to believe it’s been nearly a decade since we first met on the mean streets of "), _c('em', [_vm._v("Networking for People Who Hate Networking")]), _vm._v(", take one. We were just crazy kids with something to prove.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plenty still holds true. We remain a hapless collection of introverts, extroverts, and centroverts. There are ample networking conundrums to navigate. Opportunities persist to trip, fall, and dust off. Lots else has changed—evolved, if you will.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("The first edition sold on every continent except Antarctica. How’s that for irony? I feature penguins on my book cover, and they’re the ones who refrain from reading it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Networking")]), _vm._v(" is now translated into fifteen languages. There are videos, ebooks, audio books, executive summaries, and whatnot. Little did I know so many would have easy access to a truckload of my most embarrassing moments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Readers continue to share heartfelt stories about how "), _c('em', [_vm._v("Networking")]), _vm._v(" has changed lives, furthered careers, enabled self-acceptance, and enhanced relationships. Receiving your letters has been, by far, the best part of all.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While I’ve been speaking on networking, personality types, and pathways to real connections, you’ve provided fabulous ideas and insights on what else to integrate.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "underlev"
  }, [_vm._v("Welcome to the New and Improved Second Edition!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Beyond updates and enhancements on virtually every page, there are two additional chapters and some brand-new sections. Highlights include a chapter on follow-up, another on interpersonal networking, and a robust segment on interview tips in "), _c('span', {
    attrs: {
      "href": "#/xhtml/ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9")]), _vm._v(", “The Job Search.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This book is not only for introverts. Even devoted extroverts donning “I "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "Images",
      "src": "images/heart.jpg"
    }
  }), _vm._v(" Networking” T-shirts can reap benefits and learn new techniques. Extroverts will also gain insight into the mindset of introverts, making their own networking efforts yield stronger results.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With all the fancy upgrades (including our cutting-edge Get to It! Toolkit—check out the back pages for details) the book remains down-to-earth, practical, fun, and interactive. I encourage you to take part in the many activities offered throughout. Since the first "), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("edition, I’ve writt en two books that can augment your networking success. "), _c('em', [_vm._v("Managing for People Who Hate Managing")]), _vm._v(" introduces the Thinker–Feeler (T/F) continuum, including the interplay of T/F on the Introvert–Extrovert (I/E) spectrum. "), _c('em', [_vm._v("Singletasking")]), _vm._v(" features methods to improve mindfulness, sharpen att ention, and clarify intentions—useful skills for quality networking. The books are available in forty-five language editions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch2"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(" offers a self-assessment, providing the groundwork for your personalized method of networking. Content builds sequentially from there. The book is designed to be enjoyed front to back, yet you can opt to skip around, alighting on chapters with specific appeal. Plenty of options.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "boxh"
  }, [_c('span', {
    staticClass: "boxh1a"
  }, [_c('strong', [_vm._v("Notes from the Field")])])]), _vm._v(" "), _c('p', {
    staticClass: "boxh1"
  }, [_vm._v("The Introvert Experience")]), _vm._v(" "), _c('p', {
    staticClass: "boxline"
  }), _vm._v(" "), _c('p', {
    staticClass: "imagel"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/common.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Step right up! A dazzling, cutting-edge concept for a theme park ride. Patrons board an “Intromobile” and put on their introvert augmented reality (IAR) glasses. They then tour Introville while experiencing the world through the lens of an introvert. Small talk is more draining than three consecutive red-eye flights. Rallies—even for the most beloved cause—seem overblown. Privacy is at a premium.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Why wait until the permits get approved? Get started today with a low-tech alternative in the form of a handy book. Lines are under an hour with a FastPass."), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb38168c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prelude.vue
// module id = 78
// module chunks = 0